import { Component, computed, inject, OnInit, ViewEncapsulation, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService, User } from '@core/authentication';
import { CommonModule } from '@angular/common';

import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { initials } from '../widgets/initials';

@Component({
  selector: 'app-user-panel',
  template: `
    <div class="matero-user-panel">
      <div class="matero-user-panel-avatar-container">
        @if (user().avatar) {
          <img
            class="matero-user-panel-avatar"
            [src]="serverUrl + '/' + user().avatar"
            alt="avatar"
          />
        } @else {
          <span class="matero-user-panel-avatar cmc-avatar" aria-hidden="true">{{ avatarText() }}</span>
        }
      </div>

      <div class="matero-user-panel-info">
        <h4 class="matero-user-panel-name">
          {{ displayName() }}
        </h4>
        @if (roleName() || user().email) {
          <p class="matero-user-panel-email">{{ roleName() || user().email }}</p>
        }
      </div>

      <div class="matero-user-panel-icons">
        <button
          mat-icon-button
          routerLink="/profile/settings"
          [title]="'user.settings' | translate"
        >
          <mat-icon>settings</mat-icon>
        </button>
        <button mat-icon-button (click)="logout()" [title]="'user.logout' | translate">
          <mat-icon>exit_to_app</mat-icon>
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./user-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, MatIconButton, MatIcon, TranslateModule, RouterLink],
})
export class UserPanelComponent implements OnInit {
  private router = inject(Router);
  serverUrl = inject<string>('SERVER_URL' as any);
  private auth = inject(AuthService);

  user = signal<User>({});

  readonly displayName = computed(() => this.user().person?.firstname || this.user().name || '');
  readonly avatarText = computed(() => initials(this.displayName()));
  /** First role as text; roles come either as names or as objects with a name. */
  readonly roleName = computed(() => {
    const role = this.user().roles?.[0];
    return typeof role === 'string' ? role : (role?.name ?? '');
  });

  ngOnInit(): void {
    this.auth.user().subscribe(user => this.user.set(user));
  }

  logout() {
    this.auth.logout().subscribe(() => {
      this.router.navigateByUrl('/auth/login');
      window.location.reload();
    });
  }
}
